// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"e20275fa","435":"75ef89c0","487":"5cfad911","511":"1d40c4fc","559":"3fab6217"}[chunkId] + ".css";
};